import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  ElementRef,
  AfterViewInit,
  signal,
  inject,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { APIService } from 'src/app/services/APIService/api.service';
import { first } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { ToastService } from 'src/app/services/toast.service';
import { ClrAccordionModule, ClrDatagrid, ClrForm, ClrTabsModule } from '@clr/angular';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { BasicStoreService } from 'src/app/services/BasicStore/basic-store.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PreviewThumbnailsComponent } from '../../_shared/preview-thumbnails/preview-thumbnails.component';
import { HilfeBeschreibungModalComponent } from '../../_modals/hilfebeschreibungmodal/hilfebeschreibungmodal.component';
import { CommonModule } from '@angular/common';
import { ClarityModule } from '@clr/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HideIDColumnsPipe } from 'src/app/pipes/hide-idcolumns.pipe';
import { TablePrettyPrintPipe } from 'src/app/pipes/tablePrettyPrint.pipe';
import { ConfirmService } from 'src/app/services/confirm.service';

export interface FormulareRow {
  ID: number;
  Typ: string;
  FeldName: string;
  AuswahlOption: string;
  Bezeichnung: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-formularerstellungsdialog',
  templateUrl: './formularerstellungsdialog.component.html',
  styleUrls: ['./formularerstellungsdialog.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    PreviewThumbnailsComponent,
    HilfeBeschreibungModalComponent,
    MrTranslatePipe,
    FormsModule,
    ReactiveFormsModule,
    HideIDColumnsPipe,
    TablePrettyPrintPipe,
    ClarityModule,
    ClrAccordionModule,
    ClrTabsModule,
  ],
})
export class FormularerstellungsdialogComponent implements OnInit, AfterViewInit {
  private apiservice = inject(APIService);
  private toastr = inject(ToastService);
  private mrTranslate = inject(MrTranslatePipe);
  private basicStore = inject(BasicStoreService);
  private domSanitizer = inject(DomSanitizer);
  private confirmService = inject(ConfirmService);

  public closedialog: BehaviorSubject<boolean> = new BehaviorSubject(false);
  dataRefresh = new EventEmitter();
  set data(dataIn: any) {
    this.dataRefresh = dataIn.dataRefresh;
  }

  protected readonly isHelperModalOpen = signal(false);

  public close() {
    this.closedialog.next(true);
  }

  optionMessTable: UntypedFormGroup = new UntypedFormGroup({
    messart: new UntypedFormControl('0'),
  });

  @ViewChild(PreviewThumbnailsComponent, { static: false })
  private preview: PreviewThumbnailsComponent;

  modaltitel: string = '';
  copyformular: number = 0;
  copyvorlageID: number = 0;
  dorename: number = 0;
  copytabelle: number = 0;
  selectedformulare: any;
  selectedtabellen: any;
  cansortup: boolean = false;
  cansortdown: boolean = false;
  cansortuptabelle: boolean = false;
  cansortdowntabelle: boolean = false;
  selectionFormulareIndex: number = 0;
  selectionvorlageID: number = 0;
  isZaehlerAddVisible: boolean = false;
  structures: any;
  formulare: any;
  formulareOriginal: any;
  tabellen: any;
  tabellenOriginal: any;
  stammdaten = { rows: [] };
  spezifikationsdaten = { columns: [], mapping: {} };
  herstellerdaten = { columns: [] };
  canEdit: boolean = true;
  locked: boolean = true;
  typOptions = ['Normales Feld', 'Überschrift', 'Titel'];
  objektTypOptions = [1, 2, 3];
  auswahlOptions = ['', 'Stammdaten', 'Spezifikationsdaten', 'Herstellerdaten'];
  firstColumnId = 'Typ';
  secondColumnId = 'FeldName';
  formReflectData: {
    mainTitle: string | null;
    title: string | null;
    subheading: string | null;
    fieldType: string | null;
  }[] = [];
  vorlageNames: Array<{ ID: number; VorlageName: string }>;
  tabellenNames: Array<{ ID: number; Bezeichnung: string }>;
  tabellenNameAll: any;

  selectedVorlageName: string;
  // selectedTabelleName: string;
  selectedTabelleID: number | null = null;
  selected: any = [];
  selcode: any = '';
  selmesstyp: number = 0;
  tab: any;
  skizzen: any;
  curSkizzen: any = [];
  bemerkungmessung: string = '';
  private imagesLoadedForTable: number | null = null;
  private isMesswerteTabActive: boolean = false;

  delItems: any = [];
  // Be robust: some payloads use "ID" (backend), some use "id" (client-created). Fallback accordingly.
  trackById = (index, item) => item?.ID ?? item?.id;
  private viewInitialized: boolean = false;

  @ViewChild(ClrDatagrid) grid: ClrDatagrid;
  @ViewChild(ClrForm) form: ClrForm;

  @Output() modalOpen = new EventEmitter<boolean>();

  _currentPage: number = 1;
  set currentPage(newPage: number) {
    this._currentPage = newPage;
  }
  get currentPage() {
    return this._currentPage;
  }

  set _modalOpen(newVal: boolean) {
    this.modalOpen.emit(newVal);
  }

  tabellenName: any;

  loading: boolean = true;
  relaod: boolean = false;

  activeTab: any = {
    formulare: false,
    tabellen: false,
  };
  showRename: boolean = false;

  isVorlageAddVisible: boolean = false;
  @ViewChild('_vorlage_new') _vorlage_new: ElementRef;
  @ViewChild('_zaehlercode') _zaehlercode: ElementRef;
  @ViewChild('_zaehlerbezeichnung') _zaehlerbezeichnung: ElementRef;
  @ViewChild('newStammBez') newStammBez: ElementRef;

  constructor() {
    console.log('FormularerstellungsdialogComponent initialized');
    this.reloadVorlageNamesAndFormData();
    this.getStructures();
  }

  randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  getStructures() {
    this.apiservice
      .getFieldStructures()
      .pipe(first())
      .subscribe((val: any) => {
        this.structures = val.rows;
      });
  }

  // Ensure tables are listed in alphanumerical order by Bezeichnung
  private sortTabellenNames(): void {
    if (Array.isArray(this.tabellenNames)) {
      this.tabellenNames = [...this.tabellenNames].sort((a: any, b: any) =>
        (a?.Bezeichnung ?? '').localeCompare(b?.Bezeichnung ?? '', undefined, {
          numeric: true,
          sensitivity: 'base',
        })
      );
    }
    // Also keep the distinct Code list stable and sorted for datalist usage
    if (Array.isArray(this.tabellenName)) {
      this.tabellenName = [...this.tabellenName].sort((a: any, b: any) =>
        (a ?? '').toString().localeCompare((b ?? '').toString(), undefined, {
          numeric: true,
          sensitivity: 'base',
        })
      );
    }
  }

  selectVorlageName(selectedVorlageName: string) {
    console.log('🔵 selectVorlageName called with:', selectedVorlageName);

    if (!selectedVorlageName) {
      console.warn('🔵 No vorlage name provided');
      return;
    }

    const previousVorlageID = this.selectionvorlageID;
    this.selectedVorlageName = selectedVorlageName;
    this.selectionvorlageID = this.getVorlageIDByName(selectedVorlageName);

    console.log('🔵 Set selectionvorlageID to:', this.selectionvorlageID, '(previous:', previousVorlageID, ')');

    if (this.selectionvorlageID) {
      // Only reset image tracking when switching to a DIFFERENT template
      // Don't reset when just reloading the same template (e.g., after save)
      if (previousVorlageID !== this.selectionvorlageID) {
        console.log('🔵 🖼️ Vorlage changed, resetting image tracking');
        this.imagesLoadedForTable = null;
      } else {
        console.log('🔵 🖼️ Same vorlage reloading, keeping image tracking:', this.imagesLoadedForTable);
      }

      this.reloadTabellen();
      this.fetchDataForVorlage(this.selectionvorlageID);
    } else {
      console.error('🔵 Could not find vorlage ID for name:', selectedVorlageName);
      this.toastr.warning(this.mrTranslate.transform('Vorlage konnte nicht gefunden werden'));
    }
  }

  selectTabelleID(selectedTabelleID: number | string, saved = false, forceReload = false) {
    // Convert string to number if necessary
    const tabelleID = typeof selectedTabelleID === 'string' ? parseInt(selectedTabelleID) : selectedTabelleID;

    if (!tabelleID || isNaN(tabelleID)) {
      console.warn('Invalid table ID:', selectedTabelleID);
      return;
    }

    const tableChanged = this.selectedTabelleID !== tabelleID;
    this.selectedTabelleID = tabelleID;
    console.log('Selecting table ID:', tabelleID, 'tableChanged:', tableChanged, 'forceReload:', forceReload);

    // Reset the loaded images flag when table changes
    if (tableChanged) {
      this.imagesLoadedForTable = null;
      console.log('🖼️ Table changed, reset imagesLoadedForTable flag');
    }

    this.fetchDataForTabelleName(tabelleID);

    this.tab = this.tabellenNames?.find(tabelle => tabelle.ID === tabelleID) ?? {};
    if (saved) {
      this.tab['Bemerkung'] = this.bemerkungmessung;
    }

    this.selcode = this.tab['Code'] || '';
    this.selmesstyp = this.tab['SourceType'] || 0;
    this.bemerkungmessung = this.tab['Bemerkung'] || '';

    // Store skizzen reference but don't try to load them yet
    // They will be loaded when the Messwerte tab is clicked via onMesswerteTabClick()
    console.log('🖼️ Table', tabelleID, 'selected. Skizzen will be loaded when Messwerte tab is active.');
  }

  reloadTabellen() {
    console.log('📋 reloadTabellen called with selectionvorlageID:', this.selectionvorlageID);

    if (!this.selectionvorlageID) {
      console.warn('📋 No selectionvorlageID available for loading tables');
      return;
    }

    this.apiservice.getTabellenNamesFAT(this.selectionvorlageID).subscribe(
      namesAndIDs => {
        console.log('📋 getTabellenNamesFAT response:', namesAndIDs);

        if (namesAndIDs && namesAndIDs.data && namesAndIDs.data.rows) {
          this.skizzen = namesAndIDs.skizzen;
          console.log('📋 🖼️ Loaded skizzen data:', Object.keys(this.skizzen || {}).length, 'tables with skizzen');

          // Log which tables have skizzen
          if (this.skizzen) {
            Object.keys(this.skizzen).forEach(tableId => {
              console.log('📋 🖼️ Table', tableId, 'has', this.skizzen[tableId].length, 'skizzen');
            });
          }

          this.tabellenNames = namesAndIDs.data.rows;
          this.tabellenNameAll = namesAndIDs.data.rows;
          this.tabellenName = [...new Set(namesAndIDs.data.rows.map(item => item.Code))];

          // Sort for stable alphanumeric ordering in UI
          this.sortTabellenNames();

          console.log('📋 Loaded tabellenNames:', this.tabellenNames.length, 'tables');

          if (this.tabellenNames.length > 0) {
            this.selectedTabelleID = this.tabellenNames[0].ID;
            console.log('📋 Auto-selecting first table:', this.selectedTabelleID);
            this.selectTabelleID(this.selectedTabelleID);
          } else {
            console.log('📋 No tables found for vorlage ID:', this.selectionvorlageID);
            this.selectedTabelleID = null;
            // Clear existing table data
            this.tabellen = { rows: [], columns: [] };
          }
        } else {
          console.warn('📋 Invalid response structure from getTabellenNamesFAT:', namesAndIDs);
          this.tabellenNames = [];
          this.selectedTabelleID = null;
          this.tabellen = { rows: [], columns: [] };
        }
      },
      error => {
        console.error('Error loading table names:', error);
        this.toastr.error(this.mrTranslate.transform('Fehler beim Laden der Tabellen'));
        this.tabellenNames = [];
        this.selectedTabelleID = null;
        this.tabellen = { rows: [], columns: [] };
      }
    );

    this.apiservice
      .getTabellenFAT()
      .pipe(first())
      .subscribe(
        val => {
          this.tabellen = val;
          this.tabellenOriginal = JSON.parse(JSON.stringify(val.rows));

          // Ensure proper data structure exists
          if (!this.tabellen.columns) {
            this.tabellen.columns = [];
          }
          if (!this.tabellen.rows) {
            this.tabellen.rows = [];
          }

          // Only select table if we have a valid ID
          if (this.selectedTabelleID) {
            this.selectTabelleID(this.selectedTabelleID);
          }
        },
        error => {
          console.error('Error loading table data:', error);
          this.tabellen = { rows: [], columns: [] };
        }
      );
  }
  reloadVorlageNamesAndFormData() {
    this.apiservice.getVorlageNames().subscribe(
      namesAndIDs => {
        this.vorlageNames = namesAndIDs;
        // Keep Vorlagen sorted as well for UX consistency
        if (Array.isArray(this.vorlageNames)) {
          this.vorlageNames = [...this.vorlageNames].sort((a: any, b: any) =>
            (a?.VorlageName ?? '').localeCompare(b?.VorlageName ?? '', undefined, {
              numeric: true,
              sensitivity: 'base',
            })
          );
        }
        console.log('Loaded vorlage names:', namesAndIDs);

        // Always initialize the first template if no template is selected
        if (!this.selectedVorlageName && namesAndIDs && namesAndIDs.length > 0) {
          this.selectedVorlageName = namesAndIDs[0].VorlageName;
          console.log('Auto-selecting first vorlage:', this.selectedVorlageName);
          this.selectVorlageName(this.selectedVorlageName);
        } else if (this.selectedVorlageName) {
          // Reload tables for the currently selected template
          console.log('Reloading tables for current vorlage:', this.selectedVorlageName);
          this.selectVorlageName(this.selectedVorlageName);
        }
      },
      error => {
        console.error('Error loading vorlage names:', error);
        this.toastr.error(this.mrTranslate.transform('Fehler beim Laden der Vorlagen'));
      }
    );

    this.apiservice
      .getFormulare()
      .pipe(first())
      .subscribe(val => {
        this.formulare = val;
        this.formulare.rows.forEach(row => {
          if (row.Tabelle === 'Spezifikationsdaten') {
            row.Bezeichnung = this.spezifikationsdaten.mapping[row.Bezeichnung] || row.Bezeichnung;
          }
        });
        this.formulareOriginal = JSON.parse(JSON.stringify(val.rows));
      });
  }

  getVorlageIDByName(name: string): number | null {
    const vorlage = this.vorlageNames.find(
      (vorlage: { ID: number; VorlageName: string }) => vorlage.VorlageName === name
    );
    return vorlage ? vorlage.ID : null;
  }

  addZaehler() {
    if (this._zaehlercode.nativeElement.value.code == '' || this._zaehlerbezeichnung.nativeElement.value == '') {
      this.toastr.warning(this.mrTranslate.transform('Bitte füllen Sie Bereich und Bezeichnung aus.'));
      return;
    }

    const tab = this.tabellenNameAll.find(
      tab =>
        tab.Bezeichnung.toLowerCase() == this._zaehlerbezeichnung.nativeElement.value.toLowerCase() &&
        tab.Code.toLowerCase() == this._zaehlercode.nativeElement.value.toLowerCase()
    );

    if (tab !== undefined) {
      this.toastr.warning(this.mrTranslate.transform('Tabelle existiert bereits, ändern Sie die Einstellungen'));
      return;
    }

    let typ = 0;

    let vals = this.optionMessTable.value;
    typ = vals.messart;

    let data = {
      FATVOLID: this.copyvorlageID.toString(),
      code: this._zaehlercode.nativeElement.value,
      bezeichnung: this._zaehlerbezeichnung.nativeElement.value,
      typ: typ.toString(),
      copyid: this.copytabelle.toString(),
      rename: this.dorename.toString(),
    };

    this.apiservice
      .addZaehler(data)
      .pipe(first())
      .subscribe(val => {
        if (!val.toString().includes('error')) {
          this.relaod = true;
          this.isZaehlerAddVisible = false;
          this._zaehlercode.nativeElement.value = '';
          this._zaehlerbezeichnung.nativeElement.value = '';
          //this.reloadVorlageNamesAndFormData();
          this.reloadTabellen();
          this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
          this.copytabelle = 0;
          this.copyvorlageID = 0;
          this.relaod = false;
        } else {
          this.toastr.error(this.mrTranslate.transform('Daten wurden nicht gespeichert'));
        }
      });
  }

  addVorlage() {
    const isvorlage = this.vorlageNames.find(
      vorlage => vorlage.VorlageName.toLowerCase() === this._vorlage_new.nativeElement.value.toLowerCase()
    );

    if (isvorlage !== undefined) {
      this.toastr.warning(this.mrTranslate.transform('Vorlage existiert bereits'));
      return;
    }

    const newVorlageName: string = this._vorlage_new.nativeElement.value;

    let data = {
      data: newVorlageName,
      copyid: this.copyformular,
    };

    this.apiservice
      .addVorlage(data)
      .pipe(first())
      .subscribe(val => {
        if (val) {
          // Backend returns the updated list of Vorlagen; use it to select the newly created copy deterministically
          try {
            this.vorlageNames = Array.isArray(val) ? val : (val?.rows ?? []);
            // Keep list sorted for UX
            if (Array.isArray(this.vorlageNames)) {
              this.vorlageNames = [...this.vorlageNames].sort((a: any, b: any) =>
                (a?.VorlageName ?? '').localeCompare(b?.VorlageName ?? '', undefined, {
                  numeric: true,
                  sensitivity: 'base',
                })
              );
            }

            // Select the new template by its exact name
            this.selectedVorlageName = newVorlageName;
            this.selectionvorlageID = this.getVorlageIDByName(newVorlageName);

            // If we found it, load its data and tables directly
            if (this.selectionvorlageID) {
              this.reloadTabellen();
              this.fetchDataForVorlage(this.selectionvorlageID);
            } else {
              // As a fallback (should be rare), refresh lists and let user pick
              this.reloadVorlageNamesAndFormData();
              this.toastr.warning(this.mrTranslate.transform('Vorlage konnte nicht gefunden werden'));
            }

            // Reset UI state
            this.isVorlageAddVisible = false;
            this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
            this.copyformular = 0;
            this._vorlage_new.nativeElement.value = '';
          } catch (e) {
            console.error('Error processing addVorlage response', e);
            this.reloadVorlageNamesAndFormData();
            this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
          }
        } else {
          this.toastr.error(this.mrTranslate.transform('Daten wurden nicht gespeichert'));
        }
      });
  }

  selectionTabellenChanged(value: any) {
    this.cansortuptabelle = false;
    this.cansortdowntabelle = false;

    var index = this.tabellen.rows.indexOf(value);
    if (index > 0) this.cansortuptabelle = true;

    if (index < this.tabellen.rows.length - 1) this.cansortdowntabelle = true;
  }

  sortUptable() {
    var index = this.tabellen.rows.indexOf(this.selectedtabellen);
    this.tabellen.rows = this.swapArrayTabellen(this.tabellen.rows, index, index - 1);
    this.selectionTabellenChanged(this.selectedtabellen);
  }

  sortDowntable() {
    var index = this.tabellen.rows.indexOf(this.selectedtabellen);
    this.tabellen.rows = this.swapArrayTabellen(this.tabellen.rows, index, index + 1);
    this.selectionTabellenChanged(this.selectedtabellen);
  }

  swapArrayTabellen(Array: any, Swap1: number, Swap2: number): any {
    let sort1 = Array[Swap1].I_SORT;
    let sort2 = Array[Swap2].I_SORT;
    let id1 = Array[Swap1].ID;
    let id2 = Array[Swap2].ID;

    Array[Swap2].I_Sort = sort1;
    Array[Swap1].I_Sort = sort2;

    var temp = Array[Swap1];
    Array[Swap1] = Array[Swap2];
    Array[Swap2] = temp;

    let resort = {
      id1: id1,
      id2: id2,
      sort1: sort2,
      sort2: sort1,
    };

    let send = {
      rows: resort,
      images: [],
      szaehnid: 0,
    };

    this.apiservice
      .editTabellenFAT({ send })
      .pipe(first())
      .subscribe(val => {
        if (val) {
          this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
        }
      });

    return Array;
  }

  selectionFormulareChanged(value: any) {
    this.cansortup = false;
    this.cansortdown = false;

    var index = this.formulare.rows.indexOf(value);
    if (index > 1) this.cansortup = true;

    if (index < this.formulare.rows.length - 1) this.cansortdown = true;
  }

  sortUp() {
    var index = this.formulare.rows.indexOf(this.selectedformulare);
    this.formulare.rows = this.swapArray(this.formulare.rows, index, index - 1);
    this.selectionFormulareChanged(this.selectedformulare);
  }

  sortDown() {
    var index = this.formulare.rows.indexOf(this.selectedformulare);
    this.formulare.rows = this.swapArray(this.formulare.rows, index, index + 1);
    this.selectionFormulareChanged(this.selectedformulare);
  }

  swapArray(Array: any, Swap1: number, Swap2: number): any {
    let sort1 = Array[Swap1].Sorting;
    let sort2 = Array[Swap2].Sorting;
    let id1 = Array[Swap1].id ?? Array[Swap1].ID;
    let id2 = Array[Swap2].id ?? Array[Swap2].ID;

    Array[Swap2].Sorting = sort1;
    Array[Swap1].Sorting = sort2;

    var temp = Array[Swap1];
    Array[Swap1] = Array[Swap2];
    Array[Swap2] = temp;

    let resort = {
      id1: id1,
      id2: id2,
      sort1: sort2,
      sort2: sort1,
    };

    this.apiservice
      .editSortTabellen({ resort })
      .pipe(first())
      .subscribe(val => {
        if (val) {
          this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
        }
      });

    return Array;
  }

  getvalue(row) {
    switch (row['Tabelle']) {
      case 'Stammdaten':
        if (row['Typ'] == 'Überschrift' || row['Typ'] == 'Titel') {
          return '';
        }

        let v = this.stammdaten.rows.find(x => x.FeldName === row['Bezeichnung']);
        if (v != undefined) {
          return v['Bezeichnung'];
        }

        break;
      case 'Spezifikationsdaten':
        if (row['Typ'] == 'Überschrift' || row['Typ'] == 'Titel') {
          return '';
        }

        return this.spezifikationsdaten.mapping[row.Bezeichnung];
        break;
      case 'Herstellerdaten':
        if (row['Typ'] == 'Überschrift' || row['Typ'] == 'Titel') {
          return '';
        }

        return row['Bezeichnung'];
        break;
      default:
        return '';
    }
  }
  getvalueTab(row) {
    switch (row['Typ']) {
      case 'Überschrift':
      case 'Titel':
        return '';
        break;
      default:
        return row['Tabelle'];
    }
  }

  fetchDataForVorlage(vorlageID: number) {
    console.log('🔵 fetchDataForVorlage called with vorlageID:', vorlageID);
    this.apiservice.getFormDataForVorlage(vorlageID).subscribe(data => {
      console.log('🔵 fetchDataForVorlage response received, data is array:', Array.isArray(data));
      if (Array.isArray(data)) {
        // Ensure formulare object exists
        if (!this.formulare) {
          console.warn('⚠️ formulare was undefined, initializing');
          this.formulare = { rows: [], columns: [] };
        }
        this.formulare.rows = data;
        console.log('🔵 Set formulare.rows with', data.length, 'items');

        this.formReflectData = data.map((row: FormulareRow) => {
          const reflectData = {
            mainTitle: null,
            title: null,
            subheading: null,
            fieldType: row['Bezeichnung'],
          };
          this.updateFormReflectData(row, reflectData);
          return reflectData;
        });
      }
    });
  }

  fetchDataForTabelleName(szaehnID: number) {
    if (!szaehnID) {
      console.log('🟡 fetchDataForTabelleName: no szaehnID provided');
      return;
    }

    console.log('🟡 fetchDataForTabelleName called with szaehnID:', szaehnID);

    // Ensure tabellen object exists before clearing
    if (!this.tabellen) {
      console.log('🟡 Initializing tabellen object');
      this.tabellen = { rows: [], columns: [] };
    } else if (this.tabellen.rows) {
      console.log('🟡 Clearing existing tabellen.rows');
      this.tabellen.rows = [];
    }

    this.apiservice.getTabellenDataFATBySZAEHNID(szaehnID).subscribe(
      data => {
        console.log(
          '🟡 getTabellenDataFATBySZAEHNID response received, has rows:',
          Array.isArray(data.rows),
          'count:',
          data.rows?.length
        );
        if (Array.isArray(data.rows)) {
          // Double-check tabellen exists (in case of race condition)
          if (!this.tabellen) {
            console.warn('⚠️ tabellen became undefined during async operation, reinitializing');
            this.tabellen = { rows: [], columns: [] };
          }
          this.tabellen.rows = data.rows;
          console.log('🟡 Set tabellen.rows with', data.rows.length, 'items');

          // Trigger a safe grid resize after data is loaded without toggling lock state
          setTimeout(() => this.safeResizeGrid(), 100);
        } else {
          console.warn('No data rows received for table ID:', szaehnID);
          // Initialize empty structure if no data
          if (!this.tabellen) {
            this.tabellen = { rows: [], columns: [] };
          } else {
            this.tabellen.rows = [];
          }
        }
      },
      error => {
        console.error('Error loading table data:', error);
        // Initialize empty structure on error
        if (!this.tabellen) {
          this.tabellen = { rows: [], columns: [] };
        } else {
          this.tabellen.rows = [];
        }
      }
    );

    // Image loading is now handled by selectTabelleID to prevent reload on tab switches
  }

  tabChange() {
    this.selected = [];
    this.currentPage = 1;
  }

  /**
   * Called when Messwerte tab button is clicked
   * Load skizzen ONCE after tab becomes active
   */
  onMesswerteTabClick() {
    console.log('🔵 Messwerte tab clicked');
    this.tabChange();

    // Use setTimeout to ensure Angular has finished rendering the preview component
    setTimeout(() => {
      this.loadSkizzenForCurrentTable();
    }, 100);
  }

  /**
   * Load skizzen for the currently selected table into the preview component
   * This method includes duplicate-check to prevent reloading the same table's images
   */
  private loadSkizzenForCurrentTable() {
    if (!this.selectedTabelleID) {
      console.warn('🖼️ No table selected, cannot load skizzen');
      return;
    }

    // Check if we already loaded images for this table
    if (this.imagesLoadedForTable === this.selectedTabelleID) {
      console.log('🖼️ Skizzen already loaded for table:', this.selectedTabelleID, '- skipping');
      return;
    }

    const skizzenForTable = this.skizzen[this.selectedTabelleID.toString()];

    if (!skizzenForTable || skizzenForTable.length === 0) {
      console.log('🖼️ No skizzen available for table:', this.selectedTabelleID);
      this.curSkizzen = [];
      return;
    }

    console.log('🖼️ Found', skizzenForTable.length, 'skizzen for table:', this.selectedTabelleID);
    this.curSkizzen = skizzenForTable;

    // Check if preview component is available
    if (!this.preview) {
      console.warn('🖼️ ❌ Preview component not yet available');
      return;
    }

    console.log('🖼️ ✅ Unpacking', this.curSkizzen.length, 'files to preview component');
    this.preview.unpackFiles(this.curSkizzen);
    this.imagesLoadedForTable = this.selectedTabelleID;
    console.log('🖼️ ✅ Successfully loaded skizzen for table:', this.selectedTabelleID);
  }

  sendForFormulare() {
    let a = this.formulare.rows;
    let b = this.formulareOriginal;
    var c = distinctByEveryProperty(a, b);
    let test = true;
    const vorlageID = this.getVorlageIDByName(this.selectedVorlageName);
    c.forEach((changedFormulare: any) => {
      if (!changedFormulare || !changedFormulare.Typ) {
        this.toastr.warning(this.mrTranslate.transform('Bitte bei der Zeile den Typ angeben.'));
        test = false;
        return;
      }

      if (!changedFormulare || !changedFormulare.FeldName) {
        this.toastr.warning(this.mrTranslate.transform('Bitte bei der Zeile den Namen angeben.'));
        test = false;
        return;
      }

      changedFormulare.VorlageID = this.getVorlageIDByName(this.selectedVorlageName);
      if (changedFormulare.Tabelle === 'Spezifikationsdaten' && changedFormulare.Bezeichnung) {
        const key = Object.keys(this.spezifikationsdaten.mapping).find(
          k => this.spezifikationsdaten.mapping[k] === changedFormulare.Bezeichnung
        );
        changedFormulare.Bezeichnung = key || changedFormulare.Bezeichnung;
      }
    });
    if (test) {
      // const tabelleIDUpdates = Object.entries(this.tabellenCheckboxStates[this.selectedVorlageName])
      //   .filter(([id, checked]) => checked)
      //   .map(([id]) => parseInt(id));

      if (vorlageID !== undefined) {
        this.apiservice
          .editFormulare(c, vorlageID, null)
          .pipe(first())
          .subscribe(val => {
            if (val) {
              this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
              this.selectVorlageName(this.selectedVorlageName);
              this.formulare = val;

              /*
            this.apiservice.getAnlagen().pipe(first()).subscribe((data: any) => {
              this.basicStore.setComponentStore('anlagen', {
                anlagen: data
              });
            });
            this.dataRefresh.emit(true);
            */
            }
          });
      } else {
        console.error('Missing vorlageID or no checkboxes selected');
      }
      this.locked = true;
    }
  }

  async sendForTabellen() {
    const index = this.tabellenNames.findIndex(x => x.ID === this.selectedTabelleID);
    if (index > 0) {
      this.tabellenNames[index]['Bemerkung'] = this.bemerkungmessung;

      let t = this.tabellenNames[index];
    }

    let a = this.tabellen.rows;
    let b = this.tabellenOriginal;
    var c = distinctByEveryProperty(a, b);
    let test = true;
    c.forEach((changedTabellen: any) => {
      if (!changedTabellen || !changedTabellen.Code) {
        this.toastr.warning(this.mrTranslate.transform('Bitte bei der Zeile den Code angeben.'));
        test = false;
        return;
      }
      changedTabellen.SZAEHNID = this.selectedTabelleID;
    });
    if (test) {
      /*
          let r = this.tabellenNames.find((row: any) => row.ID === this.selectedTabelleID);
          r["Bemerkung"] = this.bemerkungmessung;
      */

      this.tabellen.rows = [];

      let images;

      try {
        images = await this.preview.packUnsavedFiles();
      } catch (_) {
        this.toastr.error(this.mrTranslate.transform('Beim Speichern von Bilder und Video ist ein Fehler aufgetreten'));
      }

      let send = {
        rows: c,
        images: images,
        savedFiles: this.preview
          .saved()
          ?.map(file => file.name)
          .join('|'),
        szaehnid: this.selectedTabelleID,
        bemerkung: this.bemerkungmessung,
      };
      //this.preview.setSaved();

      this.apiservice
        .editTabellenFAT(send)
        .pipe(first())
        .subscribe((val: any) => {
          this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
          this.tabellen.rows = val.data.rows;

          // Update skizzen cache with server response
          Object.keys(this.skizzen).forEach(typid => {
            if (typid == this.selectedTabelleID.toString()) {
              this.skizzen[typid] = val.skizzen;
              this.curSkizzen = val.skizzen;
            }
          });

          // Reload images from server after save
          setTimeout(() => {
            if (this.preview != undefined) {
              this.preview.clearPreview();
              if (this.curSkizzen.length > 0) {
                this.preview.unpackFiles(this.curSkizzen);
              }
              this.imagesLoadedForTable = this.selectedTabelleID;
            }
          }, 200);

          this.bemerkungmessung = send.bemerkung;
          this.selectTabelleID(this.selectedTabelleID, true);
        });
    }
  }

  private updateFormReflectData(row: any, reflectData: any) {
    if (row[this.firstColumnId] === 'Überschrift') {
      reflectData.mainTitle = null;
      reflectData.title = row['FeldName'];
      reflectData.subheading = null;
    } else if (row[this.firstColumnId] === 'Normales Feld') {
      reflectData.mainTitle = null;
      reflectData.title = null;
      reflectData.subheading = row['FeldName'];
    } else if (row[this.firstColumnId] === 'Titel') {
      reflectData.mainTitle = row['FeldName'];
      reflectData.title = null;
      reflectData.subheading = null;
    }
    let columnName = row['Bezeichnung'];

    if (columnName != null && this.structures) {
      let stable = 'ostamm';

      if (row['Tabelle'] === 'Spezifikationsdaten') stable = 'ospez';

      if (row['Tabelle'] === 'Herstellerdaten') stable = 'oherst';

      const rowToDelete = this.structures.find(
        (row: any) => row.TABLE_NAME === stable && row.COLUMN_NAME === columnName
      );

      if (rowToDelete != undefined) {
        let formFieldType;
        switch (rowToDelete.DATA_TYPE.toUpperCase()) {
          case 'VARCHAR':
          case 'TEXT':
            formFieldType = 'text';
            break;
          case 'DATETIME':
            formFieldType = 'date';
            break;
          case 'DECIMAL':
          case 'INT':
          case 'FLOAT':
            formFieldType = 'dropdown';
            break;
          case 'BIT':
            formFieldType = 'checkbox';
            break;
        }
        reflectData.fieldType = formFieldType;
      }
    }
  }

  async deleteForFormulare() {
    const ok = await this.confirmService.danger(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie diese Zeile(n) löschen wollen?')
    );

    if (ok) {
      for (const _id in this.delItems) {
        const id = this.delItems[_id];

        // If it is a server-side row (numeric ID), call API; if it's a client-only temp row (e.g. 'INSERT...'), just remove locally
        if (typeof id === 'number') {
          this.apiservice
            .deleteFormular(id)
            .pipe(first())
            .subscribe(() => {
              // no-op; optimistic update below will adjust UI
            });
        }

        const indexF = this.formulare.rows.findIndex(x => (x.ID ?? x.id) === id);
        if (indexF >= 0) {
          this.formulare.rows.splice(indexF, 1);
        }
      }

      this.toastr.success(this.mrTranslate.transform('Zeile(n) gelöscht'));
      this.delItems = [];

      //this.locked = true;
    }
  }

  onItemChanged(event: Event, row: any, _i: any) {
    const checkbox = event.target as HTMLInputElement;
    const rowId = row?.ID ?? row?.id;
    const indexF = this.formulare.rows.findIndex(x => (x.ID ?? x.id) === rowId);

    if (indexF >= 0 && rowId !== undefined) {
      const marked = !!checkbox.checked;
      if (marked) {
        if (!this.delItems.includes(rowId)) {
          this.delItems.push(rowId);
        }
      } else {
        const _index = this.delItems.findIndex(x => x === rowId);
        if (_index > -1) this.delItems.splice(_index, 1);
      }
    } else {
      // Unknown row; revert visual toggle for safety
      if (checkbox.checked) checkbox.checked = false;
    }
  }

  async deleteForTabellen(id: any) {
    let index = this.tabellen.rows.findIndex(x => x.ID === id);
    if (id.toString().indexOf('INSERT') > -1) {
      this.tabellen.rows.splice(index, 1);
      return;
    }

    if (index > 0) {
      const ok = await this.confirmService.danger(
        this.mrTranslate.transform('Sind Sie sicher, dass Sie diese Zeile löschen wollen?')
      );
      if (ok) {
        this.apiservice
          .deleteTabelle(id)
          .pipe(first())
          .subscribe(val => {
            if (val) {
              this.toastr.success(this.mrTranslate.transform('Zeile gelöscht'));

              if (index > -1) {
                this.tabellen.rows.splice(index, 1);
              }
            }
          });
        //this.locked = true;
      }
    }
  }

  addFormulare() {
    this.modaltitel = this.mrTranslate.transform('Neue Vorlage erstellen');
    this.isVorlageAddVisible = true;
  }

  saveAsFormulare() {
    this.copyformular = this.getVorlageIDByName(this.selectedVorlageName);
    this._vorlage_new.nativeElement.value = this.selectedVorlageName + ' - ' + this.mrTranslate.transform('Kopie');
    this.modaltitel = this.mrTranslate.transform('Speichern unter');
    this.isVorlageAddVisible = true;
  }

  renameFormulare() {
    let id = this.getVorlageIDByName(this.selectedVorlageName);
    let newbez = this.newStammBez.nativeElement.value;

    let data = {
      status: 'rename',
      id: id,
      data: newbez,
    };

    this.apiservice
      .addVorlage(data)
      .pipe(first())
      .subscribe(val => {
        if (val) {
          this.reloadVorlageNamesAndFormData();
          this.showRename = false;
          this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
          this.copyformular = 0;
          this.selectedVorlageName = this.newStammBez.nativeElement.value;
          this.selectVorlageName(this.selectedVorlageName);
          this.newStammBez.nativeElement.value = '';
        } else {
          this.toastr.error(this.mrTranslate.transform('Daten wurden nicht gespeichert'));
        }
      });
  }

  async deleteFormulare() {
    const ok = await this.confirmService.danger(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie diese Vorlage löschen wollen?')
    );
    if (ok) {
      const deletedName = this.selectedVorlageName;
      const deletedIndex =
        Array.isArray(this.vorlageNames) ? this.vorlageNames.findIndex(v => v?.VorlageName === deletedName) : -1;

      let id = this.getVorlageIDByName(deletedName);

      this.apiservice
        .deleteFormularName(id)
        .pipe(first())
        .subscribe(() => {
          this.toastr.success(this.mrTranslate.transform('Vorlage gelöscht'));

          // Fetch fresh list, pick neighbor, and load it without warning
          this.apiservice
            .getVorlageNames()
            .pipe(first())
            .subscribe((namesAndIDs: any[]) => {
              this.vorlageNames = Array.isArray(namesAndIDs) ? namesAndIDs : [];
              // Keep list sorted
              if (Array.isArray(this.vorlageNames)) {
                this.vorlageNames = [...this.vorlageNames].sort((a: any, b: any) =>
                  (a?.VorlageName ?? '').localeCompare(b?.VorlageName ?? '', undefined, {
                    numeric: true,
                    sensitivity: 'base',
                  })
                );
              }

              if (!this.vorlageNames.length) {
                // No templates left; clear selection and data structures
                this.selectedVorlageName = '' as any;
                this.selectionvorlageID = 0;
                this.formulare = { rows: [], columns: [] } as any;
                this.tabellen = { rows: [], columns: [] } as any;
                return;
              }

              // Choose neighbor: same index if possible, otherwise previous available, otherwise last
              const fallbackIndex = Math.max(0, Math.min(deletedIndex, this.vorlageNames.length - 1));
              const fallbackName = this.vorlageNames[fallbackIndex].VorlageName;

              this.selectedVorlageName = fallbackName;
              this.selectionvorlageID = this.getVorlageIDByName(fallbackName) ?? 0;

              if (this.selectionvorlageID) {
                this.fetchDataForVorlage(this.selectionvorlageID);
                this.reloadTabellen();
              } else {
                // As a last resort, re-run the standard loader which will pick the first
                this.reloadVorlageNamesAndFormData();
              }
            });
        });
    }
  }

  addForFormulare() {
    let blank = JSON.parse(JSON.stringify(this.formulare.rows[0]));
    for (let key in blank) {
      blank[key] = undefined;
    }
    const tempId = 'INSERT' + this.randomIntFromInterval(1000000000, 9999999999);
    // Set both to stay compatible with different code paths
    blank['ID'] = tempId;
    blank['id'] = tempId;
    blank['Sorting'] = this.formulare.rows.length + 1;

    this.formulare.rows.push(blank);
    setTimeout(() => {
      this.grid.resize();
      document.getElementById('saveButton').scrollIntoView(true);
    });
  }

  addTabelle() {
    this.dorename = 0;
    this.copyvorlageID = this.selectionvorlageID;
    this.copytabelle = -1; //this.selectedTabelleID;

    this._zaehlercode.nativeElement.value = '';
    this._zaehlerbezeichnung.nativeElement.value = '';
    this.optionMessTable.controls.messart.setValue(0);

    this.modaltitel = this.mrTranslate.transform('Neue Messwerttabelle erstellen');
    this.isZaehlerAddVisible = true;
  }

  renameTabelle() {
    this.dorename = 1;
    this.copyvorlageID = this.selectionvorlageID;
    this.copytabelle = this.selectedTabelleID; //this.getVorlageIDByName(this.selectedVorlageName);

    const tab = this.tabellenNames.find(tabelle => tabelle.ID === parseInt(this.copytabelle.toString()));

    this._zaehlercode.nativeElement.value = tab['Code'];
    this._zaehlerbezeichnung.nativeElement.value = tab['Bezeichnung'];

    this.optionMessTable.controls.messart.setValue(tab['SourceType']);

    this.modaltitel = this.mrTranslate.transform('Umbenennen');
    this.isZaehlerAddVisible = true;
  }

  saveAsTabelle() {
    this.dorename = 0;
    this.copyvorlageID = this.selectionvorlageID;
    this.copytabelle = this.selectedTabelleID; //this.getVorlageIDByName(this.selectedVorlageName);

    const tab = this.tabellenNames.find(tabelle => tabelle.ID === parseInt(this.copytabelle.toString()));

    this._zaehlercode.nativeElement.value = tab['Code'];
    this._zaehlerbezeichnung.nativeElement.value = tab['Bezeichnung'] + ' - copy';

    this.optionMessTable.controls.messart.setValue(tab['SourceType']);

    this.modaltitel = this.mrTranslate.transform('Speichern unter');
    this.isZaehlerAddVisible = true;
  }

  async deleteTabelle() {
    const ok = await this.confirmService.danger(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie diese Tabelle löschen wollen?')
    );
    if (ok) {
      let id = this.selectedTabelleID;
      this.apiservice
        .deleteTabelleName(id)
        .pipe(first())
        .subscribe(val => {
          if (val) {
            this.toastr.success(this.mrTranslate.transform('Tabelle gelöscht'));

            this.reloadTabellen();
          }
        });
      this.locked = true;
    }
  }

  addForTabellen() {
    // Create a new row with proper default values
    let blank: any = {};

    // Get column structure from existing rows or columns
    if (this.tabellen.rows && this.tabellen.rows.length > 0) {
      // Copy structure from first row
      const template = this.tabellen.rows[0];
      for (let key in template) {
        if (key === 'ZArt') {
          blank[key] = template[key]; // Preserve ZArt (measurement type)
        } else if (key === 'Soll' || key === 'Tol +' || key === 'Tol -') {
          blank[key] = '0'; // Initialize numeric fields with '0' string for display
        } else {
          blank[key] = ''; // Initialize other fields with empty string
        }
      }
    } else if (this.tabellen.columns) {
      // Build from column definitions
      for (let col of this.tabellen.columns) {
        if (col.id === 'Soll' || col.id === 'Tol +' || col.id === 'Tol -') {
          blank[col.id] = '0';
        } else {
          blank[col.id] = '';
        }
      }
    }

    blank['ID'] = 'INSERT' + this.randomIntFromInterval(1000000000, 9999999999);
    blank['I_SORT'] = this.tabellen.rows.length + 1;
    this.tabellen.rows.push(blank);
    setTimeout(() => {
      this.grid.resize();
      document.getElementById('saveButton').scrollIntoView(true);
    });
  }

  triggerLock() {
    this.locked = !this.locked;
    this.delItems = [];

    // Enhanced defensive programming with lifecycle management
    try {
      // Check ViewChild lifecycle completion
      if (!this.viewInitialized) {
        console.warn('triggerLock called before ViewChild initialization completed');
        return;
      }

      // Check grid existence and method availability
      if (this.grid && typeof this.grid.resize === 'function') {
        // Use setTimeout to ensure DOM updates are complete before resize
        setTimeout(() => {
          try {
            this.grid.resize();
            // this.grid.refresh.emit();
            console.log('Grid resize completed successfully');
          } catch (resizeError) {
            console.error('Grid resize failed:', resizeError);
          }
        }, 0);
      } else {
        console.warn('Grid not available or resize method not found');
      }
    } catch (error) {
      console.error('triggerLock failed:', error);
      // Graceful degradation - continue execution even if grid operations fail
    }
  }

  handleAuswahlOptionChange(row: any, value: string) {
    row['Tabelle'] = value;
  }

  handleModalReload() {
    this.reloadVorlageNamesAndFormData();
    this.reloadTabellen();
  }

  // Debug helper method to check data state
  debugDataState() {
    console.log('=== Data State Debug ===');
    console.log('vorlageNames:', this.vorlageNames);
    console.log('selectedVorlageName:', this.selectedVorlageName);
    console.log('selectionvorlageID:', this.selectionvorlageID);
    console.log('tabellenNames:', this.tabellenNames);
    console.log('selectedTabelleID:', this.selectedTabelleID);
    console.log('tabellen:', this.tabellen);
    console.log('tabellen.rows:', this.tabellen?.rows);
    console.log('tabellen.columns:', this.tabellen?.columns);
    console.log('selmesstyp:', this.selmesstyp);
    console.log('relaod flag:', this.relaod);
    console.log('========================');
  }

  ngOnInit() {
    this.copyformular = 0;
    this.apiservice
      .getStammdatenColumns()
      .pipe(first())
      .subscribe(data => {
        let r = data.rows;
        r.forEach(row => {
          row['Bezeichnung'] = this.mrTranslate.transform(row['Bezeichnung']);
        });
        r.sort((a, b) => a.Bezeichnung.localeCompare(b.Bezeichnung));

        this.stammdaten.rows = r;
      });
    this.apiservice
      .getSpezifikationsdaten()
      .pipe(first())
      .subscribe(data => {
        this.spezifikationsdaten.columns = data.columns.map(col => {
          return {
            display: col,
            value: Object.keys(data.mapping).find(key => data.mapping[key] === col),
          };
        });

        this.spezifikationsdaten.columns = this.spezifikationsdaten.columns.sort((a, b) =>
          a.display.localeCompare(b.display)
        );
        this.spezifikationsdaten.mapping = data.mapping;
      });
    this.apiservice
      .getHerstellerdatenColumns()
      .pipe(first())
      .subscribe(columns => {
        this.herstellerdaten.columns = columns;
      });
  }

  ngAfterViewInit() {
    // ViewChild lifecycle management: Ensure grid is properly initialized
    // This lifecycle hook is called after Angular has fully initialized all child components
    this.viewInitialized = true;
    // Note: Grid ViewChild may be null if the Vorlagen tab is not active yet - this is expected behavior
    // The grid will be initialized when the tab becomes active
  }

  ngAfterViewChecked() {
    // Note: Image loading is now handled by onMesswerteTabActive() when the tab becomes active
    // This ensures the preview component is available before trying to load skizzen
  }

  // Resize helper without toggling lock state; avoids side-effects in UI like disappearing inputs
  private safeResizeGrid() {
    try {
      if (!this.viewInitialized) return;
      if (this.grid && typeof this.grid.resize === 'function') {
        setTimeout(() => {
          try {
            this.grid.resize();
          } catch (_) {
            /* no-op */
          }
        }, 0);
      }
    } catch (_) {
      /* no-op */
    }
  }
}

/** @deprecated find an alternative */
function distinctByEveryProperty(a: any[], b: any[]) {
  return a.filter(objA => !b.some(objB => Object.keys(objB).every(key => objB[key] === objA[key])));
}
